import { Link } from 'react-router-dom';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import { getStudentSignUpUrl } from '../GlobalFunctions';
import styles from '../SCSS/ModeSelector.module.scss';
import libraryStyles from '../SCSS/Library.module.scss';
import { AddStudentModeType } from '../../peekapak-types/DataProtocolTypes';

const VerticalDivider = ({ children }) => {
  return (
    <div className={styles.dividerWrapper}>
      <div className={styles.dividerLine} />
      <div className={styles.dividerWordWrapper}>
        <div className={styles.dividerWord}>{children}</div>
      </div>
    </div>
  );
};

const ManualModeButton = ({ onClick }) => {
  return (
    <div className={styles.modeButton}>
      <div>
        You will type in students’ names to create accounts on their behalf, and manually input parents’ email addresses
        for those who want to connect. Optionally, import students from Google Classroom, Clever or ClassLink in the{' '}
        <Link to='/classroom' className={libraryStyles.textLink}>
          Classroom Settings
        </Link>{' '}
        page.
      </div>
      <PrimaryButton onClick={onClick}>
        Manual Entry<i className='fa fa-users fa-lg' aria-hidden='true'></i>
      </PrimaryButton>
    </div>
  );
};

const ClassCodeModeButton = ({ onClick }) => {
  return (
    <div className={styles.modeButton}>
      <div>
        Parents create accounts for their child using the classroom code on the{' '}
        <a
          href={`${getStudentSignUpUrl()[0]}`}
          target='_blank'
          rel='noreferrer noopener'
          className={libraryStyles.textLink}
        >
          Peekaville website
        </a>
        . Parents will also be prompted to connect their email address so that they can stay up to date on Peekapak
        progress and lessons.
      </div>
      <PrimaryButton onClick={onClick}>
        Class Code<i className='fa fa-qrcode fa-lg' aria-hidden='true'></i>
      </PrimaryButton>
    </div>
  );
};

interface ModeSelectorProps {
  onUpdateAddStudentMode: (arg0: string) => void;
}

const ModeSelector = ({ onUpdateAddStudentMode }: ModeSelectorProps): JSX.Element => {
  const setManualMode = (event) => {
    onUpdateAddStudentMode(AddStudentModeType.MANUAL);
  };

  const setClassCodeMode = (event) => {
    onUpdateAddStudentMode(AddStudentModeType.CLASS_CODE);
  };

  return (
    <div className={styles.modeSelector}>
      <ManualModeButton onClick={setManualMode} />
      <VerticalDivider>or</VerticalDivider>
      <ClassCodeModeButton onClick={setClassCodeMode} />
    </div>
  );
};

export default ModeSelector;
